import {
    Building2,
    Factory,
    GraduationCap,
    Hospital,
    ShoppingBag,
    Hotel,
    Warehouse,
    Banknote,
} from "lucide-react";

const INDUSTRIES = [
    { label: "Corporativo", icon: Building2, testid: "ind-corp" },
    { label: "Industria & Manufactura", icon: Factory, testid: "ind-industry" },
    { label: "Educación", icon: GraduationCap, testid: "ind-edu" },
    { label: "Salud", icon: Hospital, testid: "ind-health" },
    { label: "Retail", icon: ShoppingBag, testid: "ind-retail" },
    { label: "Hospitalidad", icon: Hotel, testid: "ind-hospitality" },
    { label: "Logística", icon: Warehouse, testid: "ind-logistics" },
    { label: "Financiero", icon: Banknote, testid: "ind-finance" },
];

const Industries = () => {
    return (
        <section
            id="industrias"
            data-testid="industries-section"
            className="border-b border-white/10"
        >
            <div className="px-6 md:px-12 lg:px-16 py-20 md:py-28">
                <div className="grid grid-cols-12 gap-6 items-end mb-14">
                    <div className="col-span-12 md:col-span-8">
                        <p className="text-xs md:text-sm font-mono tracking-[0.3em] uppercase text-white/50 mb-4">
                            / 005 — Industrias
                        </p>
                        <h2 className="font-display uppercase leading-[0.9] tracking-tighter text-5xl md:text-6xl lg:text-7xl">
                            Donde operamos.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-4">
                        <p className="font-mono text-sm text-white/60 leading-relaxed">
                            Sectores donde la continuidad y la seguridad no son
                            negociables.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 border-l border-t border-white/10">
                    {INDUSTRIES.map((i) => {
                        const Icon = i.icon;
                        return (
                            <div
                                key={i.testid}
                                data-testid={i.testid}
                                className="group border-r border-b border-white/10 p-8 md:p-10 flex flex-col gap-6 hover:bg-white hover:text-black transition-colors cursor-default"
                            >
                                <Icon
                                    size={28}
                                    className="text-[#1A9EC9] group-hover:text-black"
                                />
                                <div className="font-display uppercase text-xl md:text-2xl tracking-tight">
                                    {i.label}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Industries;
